// Toggle the mobile nav overlay. Toggles live in partials/site-header.hbs
// (the burger) and partials/nav-mobile.hbs (the close X), both marked with
// [data-nav-toggle]; the overlay is partials/nav-mobile.hbs with
// [data-nav-overlay] and a `hidden` attribute on first paint.

export default function menuOpen() {
    const toggles = document.querySelectorAll('[data-nav-toggle]');
    const overlay = document.querySelector('[data-nav-overlay]');
    if (!toggles.length || !overlay) return;

    // The burger (first toggle, in source order) carries aria-expanded.
    const opener = toggles[0];

    const setOpen = (open) => {
        if (open) {
            overlay.removeAttribute('hidden');
            document.body.classList.add('nav-open');
        } else {
            overlay.setAttribute('hidden', '');
            document.body.classList.remove('nav-open');
        }
        opener.setAttribute('aria-expanded', String(open));
    };

    toggles.forEach((t) => {
        t.addEventListener('click', () => setOpen(overlay.hasAttribute('hidden')));
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) setOpen(false);
    });
}
